import firebase from 'firebase'
import { Map } from 'immutable'
import uuid from 'uuid/v4'
import xhr from 'xhr'

firebase.initializeApp({
  apiKey: "AIzaSyDcijiAgT0Rjnm6QVdOpbJWPRrXaB3VMiw",
  authDomain: "spir-24ee3.firebaseapp.com",
  databaseURL: "https://spir-24ee3.firebaseio.com",
  projectId: "spir-24ee3",
  storageBucket: "spir-24ee3.appspot.com",
  messagingSenderId: "487562658017"
});

export const currentUser = () => firebase.auth().currentUser.uid
export const timestamp = firebase.database.ServerValue.TIMESTAMP

export const db = firebase.database()
export const auth = firebase.auth()
export const storage = firebase.storage()

export const uploadImage = image =>
  firebase
    .storage()
    .ref(`images/${uuid()}`)
    .put(image)
    .then(snap => ({full: snap.ref.location.path, thumb: snap.ref.location.path.replace('images/', 'images/thumb_')}))

const mapConsultants = ([info, experience]) =>
  Map(info)
    .filter(user => user.type === 'consultant')
    .map((value, key) => ({
      ...value,
      interests: Object.keys(value.interests || {}).map(interest =>
        decode(interest)
      ),
      titles: Object.keys(value.titles || {}).map(title => decode(title)),
      experience: Map(experience[key])
        .filter(value => !value.deleted)
        .map(value => ({
          ...value,
          roles:
            value.roles && Object.keys(value.roles).map(role => decode(role)),
          tags: value.tags && Object.keys(value.tags).map(tag => decode(tag)),
        })),
    }))

const getDownloadURLs = consultants =>
  Promise.all(
    Object.keys(consultants)
      .filter(
        id =>
          consultants[id].profilePicture &&
          consultants[id].profilePicture.startsWith('images')
      )
      .map(id => getDownloadURL(id, consultants[id].profilePicture))
  ).then(downloadURLs =>
    downloadURLs.reduce(
      (consultants, { id, profilePicture }) =>
        consultants.update(id, consultant => ({
          ...consultant,
          profilePicture,
        })),
      Map(consultants)
    )
  )

const getDownloadURL = (id, path) =>
  new Promise((resolve, reject) => {
    firebase
      .storage()
      .ref(path)
      .getDownloadURL()
      .then(profilePicture =>
        resolve({
          id,
          profilePicture,
        })
      )
      .catch(() =>
        resolve({
          id,
        })
      )
  })

let consultants

export const fetchConsultants = force =>
  new Promise((resolve, reject) => {
    if (consultants && !force) {
      resolve(consultants)
    } else {
      Promise.all([
        db
          .ref('user-info')
          .once('value')
          .then(snapshot => snapshot.val())
          .then(getDownloadURLs),
        db
          .ref('user-experience')
          .once('value')
          .then(snapshot => snapshot.val()),
      ])
        .then(res => {
          consultants = mapConsultants(res)
          resolve(consultants)
        })
        .catch(reject)
    }
  })

export const encode = string =>
  encodeURIComponent(string)
    .replace(/\./g, '%2E')
    .replace(/\//g, '%2F')

export const decode = decodeURIComponent

export const createUser = ({ name, type }) =>
  new Promise((resolve, reject) =>
    firebase
      .auth()
      .currentUser.getIdToken(true)
      .then(token => {
        xhr(
          {
            method: 'post',
            body: JSON.stringify({ name, type }),
            uri: '/api/createUser',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          },
          (error, response, body) => {
            if (error) reject(error)
            resolve(body)
          }
        )
      })
  )



// WEBPACK FOOTER //
// ./src/api/firebase.js